import React from 'react';
import { Box, Divider, Text } from '@mantine/core';

interface MenuItem {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

interface EditorContextMenuProps {
  x: number;
  y: number;
  visible: boolean;
  onClose: () => void;
  items: MenuItem[];
}

export const EditorContextMenu: React.FC<EditorContextMenuProps> = ({ x, y, visible, onClose, items }) => {
  if (!visible) return null;

  return (
    <div
      style={{ position: 'fixed', inset: 0, zIndex: 11000 }}
      onClick={onClose}
  onContextMenu={(e) => { e.preventDefault(); /* keep menu open on right-click */ }}
    >
      <Box
        style={{
          position: 'absolute',
          top: y,
          left: x,
          backgroundColor: 'var(--app-surface)',
          border: '1px solid var(--app-border)',
          borderRadius: 8,
          minWidth: 180,
          boxShadow: '0 8px 24px rgba(0,0,0,0.15)'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {items.map((item, idx) => (
          <React.Fragment key={idx}>
            {item.label === '—' ? (
              <Divider my={4} />
            ) : (
              <Box
                onClick={() => { if (!item.disabled) { item.onClick(); onClose(); } }}
                style={{
                  padding: '8px 12px',
                  cursor: item.disabled ? 'not-allowed' : 'pointer',
                  color: item.disabled ? 'var(--app-text-muted)' : 'var(--app-text-primary)'
                }}
              >
                <Text size="sm">{item.label}</Text>
              </Box>
            )}
          </React.Fragment>
        ))}
      </Box>
    </div>
  );
};

export default EditorContextMenu;
